'use client'

import React from 'react'

type Props = {
    radius: number
}

const WIDTH = 340
const HEIGHT = 220

export default function SphereChart({ radius }: Props) {
    const r = 85
    const cx = WIDTH / 2
    const cy = HEIGHT / 2 - 5

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <circle cx={cx} cy={cy} r={r} fill="#2563eb" opacity={0.14} stroke="#2563eb" strokeWidth={2} />
            {/* equator + meridian to suggest 3D */}
            <ellipse cx={cx} cy={cy} rx={r} ry={r * 0.32} fill="none" stroke="#2563eb" strokeWidth={1.3} opacity={0.6} />
            <ellipse cx={cx} cy={cy} rx={r * 0.32} ry={r} fill="none" stroke="#2563eb" strokeWidth={1.3} opacity={0.6} />
            {/* radius marker */}
            <line x1={cx} y1={cy} x2={cx + r} y2={cy} stroke="#dc2626" strokeWidth={1.5} />
            <circle cx={cx} cy={cy} r={2.5} fill="#dc2626" />
            <text x={cx + r / 2} y={cy - 8} fontSize={11} textAnchor="middle" fill="#dc2626">r = {radius.toFixed(2)}</text>
        </svg>
    )
}
